import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/modals/new/modal';
import { Button } from '@/components/ui/button';

export function DeleteFlatfinderModal({
  busy,
  open,
  onConfirm,
  onDismiss,
}: {
  busy: boolean;
  open: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <Modal
      isOpen
      open={() => {}}
      dismiss={onDismiss}
      dismissDisabled={busy}
      title={t('flatfinderFormDeleteFlatfinder')}
      className="max-w-96 rounded-lg border border-primary-light/20 shadow-lg"
    >
      <Modal.Body>
        <p className="text-center text-base text-text-secondary">
          {t('flatfinderWorkspaceDeleteConfirm')}
        </p>
        <div className="mt-6 flex justify-end gap-2">
          <Button type="button" disabled={busy} onClick={onDismiss} variant="outline">
            {t('cancel')}
          </Button>
          <Button
            type="button"
            disabled={busy}
            loading={busy}
            onClick={onConfirm}
            variant="destructive"
          >
            {t('delete')}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
